import { render, staticRenderFns } from "./DriverPlanner.vue?vue&type=template&id=4a54f34c&scoped=true&"
import script from "./DriverPlanner.vue?vue&type=script&lang=js&"
export * from "./DriverPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54f34c",
  null
  
)

export default component.exports